export const GRADIENT_ARROW_WIDTH = 48;
